hljs.registerLanguage("gf",(()=>{"use strict";return e=>({aliases:["gf"],
keywords:"abstract concrete interface instance resource incomplete of with open in cat fun def data lincat|10 lin lindef|10 linref|10 printname printname param oper flags table|10 pre case variants let in where ",
contains:[{className:"meta",begin:"--#",end:"$",relevance:0},{
variants:[e.COMMENT("--","$"),e.COMMENT("{-","-}",{contains:["self"]})]},{
className:"symbol",begin:"=>|->|:|=|\\.|\\+|\\*|!|\\||\\\\",relevance:0
},e.QUOTE_STRING_MODE,e.NUMBER_MODE,e.inherit(e.TITLE_MODE,{
begin:"^[_a-zA-Z][\\w']*"}),{begin:"{s*ss*:",relevance:10}]})})());